import {ActionButtonEnum, constGridPaginatorOption, DateFormats} from "../constant";
import {isEqual} from "lodash-es";
import moment from "moment";
import {ExportFileDetails} from "../../../api/models/response/export-file-details";
import {Calendar} from "primeng/calendar";
import {Table} from "primeng/table";
import {CommonDataListRequest} from "../../../api/models/request/common-data-list-request";

export class UtilityUtils {
  static checkNumberIsValid(inputVal: any): any {
    if (inputVal) {
      const numberValue = Number(inputVal);
      if (!isNaN(numberValue)) {
        return numberValue;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  static getGridInitialReqBody(sort?: any): any {
    return {
      pageNo: constGridPaginatorOption.defaultPageNo,
      pageSize: constGridPaginatorOption.defaultPageSize,
      search: '',
      sortOrder: sort?.order ? sort?.order : '',
      sortBy: sort?.field ? sort?.field : '',
      filters: {}
    }
  }

  static getActionReqBody(gridReq: CommonDataListRequest<any>,actionTypeEnum:number): any {
    return {
      details: {
        title: 'Apply',
        actionTypeEnum: actionTypeEnum
      },
      rowData: null,
      statusData: gridReq.filters?.isActive,
      searchData: gridReq.search
    };
  }

  static RemoveAllSpaceForGrid(value: any): any {
    if (typeof value === 'string') {
      return value.trim(); // Trim the value if it's a string
    } else {
      return value; // Return empty string for other types
    }
  }

  // For Not Pass Null Value in Api Call for String Type
  static StringIsNullOrEmpty(value: string): string {
    if (value) {
      return value.toString().trim(); // Trim the value before returning
    } else {
      return '';
    }
  }

  static NumberIsNullOrEmpty(value: any): number {
    if (value) {
      return value;
    } else {
      return 0;
    }
  }

  static ConvertToNumberOrNull(value: any): number | null {
    if (value) {
      return Number(value);
    } else {
      return null;
    }
  }

  static getIdBasedOnActionType(actionTypeEnum: ActionButtonEnum, receivedDataId: number): number {
    return actionTypeEnum === ActionButtonEnum.Update ? UtilityUtils.NumberIsNullOrEmpty(receivedDataId) : 0;
  }

  static isBothSame(obj1: any, obj2: any): boolean {
    return isEqual(obj1, obj2);
  }

  /*
 * Pagination : Modify Req Body to get All Searched Records
 * */
  static ManageAllSearchedRecordPagination(value: string, pageNo: number): number {
    if (value) {
      return constGridPaginatorOption.getAllRecordsPageNo;
    } else {
      return pageNo;
    }
  }

  // Get Custom Date Time Format Based Input Value & format
  static getCustomFormatDate(inputVal: string, inputFormat: string = DateFormats["DD/MM/YYYY"], outputFormat: string = DateFormats["YYYY-MM-DD"]): string {
    if (inputVal) {
      return moment(inputVal, inputFormat).format(outputFormat);
    } else {
      return '';
    }
  }

  /**
   * Download File
   * */
  static ExportFileDownload(fileDetails: ExportFileDetails): void {
    if (fileDetails && ('streamType' in fileDetails && 'fileName' in fileDetails && 'bytes' in fileDetails)) {
      if (fileDetails.bytes && fileDetails.streamType && fileDetails.fileName) {
        const blob: Blob = this.base64toBlob(fileDetails.bytes, fileDetails.streamType);
        const url: string = window.URL.createObjectURL(blob);
        const a: HTMLAnchorElement = document.createElement('a');
        a.href = url;
        a.download = fileDetails.fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      }
    } else
      console.warn('Details not found...!');
  }

  /**
   * Get Blob from Base64 and stream Type
   * */
  static base64toBlob(base64Data: string, contentType: string): Blob {
    const sliceSize = 512;
    const byteCharacters: string = atob(base64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {type: contentType});
  }

  /**
   * Get File Extension from Path
   * */
  static getFileExtension = (path: string): string => {
    const isSeparator = (value: string): boolean => value === '/' || value === '\\' || value === ':';
    for (let i: number = path.length - 1; i > -1; --i) {
      const value: string = path[i];
      if (value === '.') {
        if (i >= 1) {
          if (isSeparator(path[i - 1])) {
            return '';
          }
          return path.substring(i + 1).toLowerCase();
        }
        return '';
      }
      if (isSeparator(value)) {
        return '';
      }
    }
    return '';
  };

  /**
   * Get File Type From Base64
   * */
  static getTypeFromBase64(value: string): string {
    value = value ? value : '';
    const commaIndex = value.indexOf(",");
    return value.substring(0, commaIndex);
  }

  /**
   * Remove Sub String from Base64
   * */
  static removeSubStrFromBase64(value: string | ArrayBuffer): string {
    return value ? (typeof value === 'string' ? value.replace(/data:.*base64,/, "") : '') : '';
  }

  /**
   * Date Range Picker Overlay Close After Both Dates Selected
   * */
  static CloseOverlayOnDateRangeSelect(dateRangePicker: Calendar) {
    const value: any[] = (dateRangePicker && dateRangePicker.value?.length) ? dateRangePicker.value : []
    if (value.length) {
      if (!value.includes(null) && !value.includes(undefined) && !value.includes('')) {
        dateRangePicker.overlayVisible = false;
      }
    }
  }

  /* Reset Table Component */
  static resetTable(table: Table, defaultSortField?: string, defaultSortOrder?: number): void {
    table.lazy = false;
    table.reset();
    table._sortOrder = defaultSortOrder ? defaultSortOrder :-1;
    table._sortField = defaultSortField;
    table.lazy = true;
    table.sortSingle();
  }

  static getSerachFieldsFromRes(data: any): string[]{
    if (data && data['extraProperty']) {
      if (data['extraProperty']['searchFields'] && data['extraProperty']['searchFields']?.length)
        return data['extraProperty']['searchFields'];
      else return [];
    } return [];
  }


}
